import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment, { invalid } from "moment";
import DateTime from 'react-datetime'
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { log } from "logrocket";
import { withApollo } from "react-apollo";
import jsPDF from 'jspdf';



let currentDate = new Date().toJSON().slice(0, 10);

const ADD_TERMS = gql`
  mutation($params: AddTerms) {
    addTerms(params: $params)
  }`

class FeeStatusModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataClear: 0,
            defaultvalue: 0,
            feeType: 0,
            totalFee: 0,
            feeAmount: 0,
            discountFee: 0,
            termsValue: "",
            feeTypeError: "",
            totalFeeError: "",
            discountFeeError: "",
            feeAmountError: "",
            termsValueError: "",
            initialPaymentChecked: true,
            paymentArray: [],
            disableInitialPayment: false,
            paidTermsCount: 0,
            defaultArray: [],
            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,
            initial_amount: 0,
            isSubmitting: false,
        }
    };

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                dataClear: 1,
                defaultvalue: 0,
                feeType: 0,
                totalFee: "",
                feeAmount: "",
                discountFee: "",
                termsValue: "",
                termsValueError: "",
                feeTypeError: "",
                feeAmountError: "",
                initialPaymentChecked: true,
                paymentArray: [],
                disableInitialPayment: false,
                paidTermsCount: 0,
                defaultArray: [],
                submitError: "",
                loadingSpinner: 0,
                currentStep: 1,
                initial_amount: 0,
                isSubmitting: false,
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    };

    handleFeeFunction = async (e, term) => {
        const name = e?.target?.name;
        const value = e?.target?.value;

        if (name == "feeType") {
            let paymentArray = [];
            let individualDetails = this.props.individualDetails.filter((item) => item.fee_type_id == parseInt(value));

            if (this.props.studentPaymentData.length > 0) {
                paymentArray = this.props.studentPaymentData.filter((item) => item.fee_type_id == parseInt(value));

                if (paymentArray.length > 0) {

                    let totalFee = individualDetails[0].total_fee != null ? individualDetails[0].total_fee : 0;
                    let discountFee = individualDetails[0].discount != null ? individualDetails[0].discount : 0;

                    this.setState({
                        totalFee: individualDetails[0].total_fee,
                        feeAmount: totalFee - discountFee,
                        discountFee: individualDetails[0].discount != null ? individualDetails[0].discount : 0,
                        termsValue: paymentArray[0]?.no_of_terms,
                        paymentArray: paymentArray[0]?.terms,
                        disableInitialPayment: paymentArray[0]?.terms.length > 0 ? true : false,
                        initialPaymentChecked: paymentArray[0]?.terms.filter((item) => item.term_no == 0).length > 0 ? true : false,
                        paidTermsCount: paymentArray[0]?.terms.filter((item) => item.is_paid).length,
                        defaultArray: paymentArray[0]?.terms,
                    })
                } else {
                    let totalFee = value == 1 && individualDetails[0].total_fee != null ? individualDetails[0].total_fee : 0;
                    let discountFee = value == 1 && individualDetails[0].discount != null ? individualDetails[0].discount : 0;
                    this.setState({
                        totalFee: totalFee,
                        feeAmount: discountFee,
                        discountFee: "",
                        feeAmount: totalFee,
                        termsValue: "",
                        paymentArray: [],
                        disableInitialPayment: false,
                        paidTermsCount: 0,
                        defaultArray: []
                    })
                }
            } else {

                if (individualDetails.length > 0) {

                    let totalFee = individualDetails[0].total_fee != null ? individualDetails[0].total_fee : 0;
                    let discountFee = individualDetails[0].discount != null ? individualDetails[0].discount : 0;

                    this.setState({
                        totalFee: individualDetails[0].total_fee,
                        feeAmount: totalFee - discountFee,
                        discountFee: individualDetails[0].discount != null ? individualDetails[0].discount : 0,
                        termsValue: "",
                        paymentArray: [],
                        disableInitialPayment: false,
                        paidTermsCount: 0,
                        defaultArray: []
                    })
                } else {
                    this.setState({
                        totalFee: 0,
                        feeAmount: 0,
                        discountFee: 0,
                        termsValue: "",
                        paymentArray: [],
                        disableInitialPayment: false,
                        paidTermsCount: 0,
                        defaultArray: []
                    })
                }



            }
            this.setState({ feeType: value, feeTypeError: "", submitError: "", feeAmountError: "", termsValueError: "" });

        }
        else if (name == "totalFee") {

            let termsValue = "";
            let paymentArray = [];

            if (value != 0 && value != "") {
                termsValue = this.state.termsValue;
                paymentArray = this.state.paymentArray;
            }
            this.setState({ totalFee: value, feeAmountError: "", submitError: "", termsValue: termsValue, paymentArray, feeAmount: (+value - +this.state.discountFee) });

            console.log("termsValue", termsValue, this.state.termsValue);
            let e = {
                target: {
                    name: "terms",
                    value: this.state.termsValue
                }
            }

            if (value != "") {

                this.handleFeeFunction(e, this.state.termsValue);
            }


        } else if (name == "discountFee") {
            console.log("value", value, this.state.totalFee);
            let value1 = 0;
            if (value != 0 && value != "") {
                value1 = value
            }

            this.setState({ discountFee: +value, submitError: "", feeAmount: +(+this.state.totalFee - +value) });

            const delay = (ms) => new Promise((r) => setTimeout(r, ms));
            await delay(200);

            let e = {
                target: {
                    name: "terms",
                    value: this.state.termsValue
                }
            }

            if (value != "") {

                this.handleFeeFunction(e, this.state.termsValue);
            }


        } else if (name == "feeAmount") {

            let termsValue = "";
            let paymentArray = [];

            if (value != 0 && value != "") {
                termsValue = this.state.termsValue;
                paymentArray = this.state.paymentArray;
            }
            this.setState({ feeAmount: value, feeAmountError: "", submitError: "", termsValue: termsValue, paymentArray });



            console.log("termsValue", termsValue, this.state.termsValue);
            let e = {
                target: {
                    name: "terms",
                    value: this.state.termsValue
                }
            }

            if (value != "") {
                this.handleFeeFunction(e, this.state.termsValue);
            }


        } else if (name == "terms") {

            const delay = (ms) => new Promise((r) => setTimeout(r, ms));
            await delay(100);

            this.setState({ termsValue: value, termsValueError: "", submitError: "" });

            let paymentArray = [];
            let termsCount = value == 0 || value == "" ? -1 : value;
            let initialValue = 1;

            if (this.state.initialPaymentChecked) {
                initialValue = 0
            }




            let termsData = this.state.defaultArray;
            let paidAmount = 0;
            let paid_data = [];

            if (this.state.defaultArray.length > 0) {
                paid_data = this.state.defaultArray.filter((item) => item.is_paid == 1)

                if (termsData.length > 0) {
                    paidAmount = paid_data.reduce((acc, cur) => parseInt(acc) + parseInt(cur.term_amount), 0)
                }
            }


            if (termsData.length) {

                if (value <= this.state.paidTermsCount) {
                    this.setState({ termsValueError: `Terms must be greater than > ${this.state.paidTermsCount}` })
                }

                let count = parseInt(value);

                if (this.state.initialPaymentChecked) {
                    count = parseInt(value) + 1
                }


                const delay = (ms) => new Promise((r) => setTimeout(r, ms));
                await delay(200);

                let dividedAmount2 = Math.floor((+this.state.feeAmount - paidAmount) / (this.state.paymentArray.length - paid_data.length))

                console.log("dividedAmount2", dividedAmount2, count, paid_data.length, paidAmount, this.state.feeAmount, paidAmount, this.state.paymentArray.length);

                let remainder2 = (this.state.FeeInput - paidAmount) % (count - paid_data.length);

                for (let i = initialValue; i <= termsCount; i++) {

                    let terms = termsData.filter((item) => item.term_no == i);

                    if (terms.length > 0) {
                        if (terms[0].is_paid == 1) {
                            paymentArray.push({
                                term_no: i,
                                term_amount: terms[0].term_amount,
                                term_date: terms[0].term_date,
                                is_paid: terms[0].is_paid,
                                paid_date: terms[0].paid_date,
                                payment_mode_id: terms[0].payment_mode_id,
                                comments: terms[0].comments,
                                termAmountError: "",
                                dateError: "",
                            })
                        } else {
                            paymentArray.push({
                                term_no: i,
                                term_amount: dividedAmount2,
                                term_date: terms[0].term_date,
                                is_paid: terms[0].is_paid,
                                paid_date: terms[0].paid_date,
                                payment_mode_id: terms[0].payment_mode_id,
                                comments: terms[0].comments,
                                termAmountError: "",
                                dateError: "",
                            })
                        }

                    } else {

                        paymentArray.push({
                            term_no: i,
                            term_amount: 0,
                            term_date: "",
                            is_paid: 0,
                            paid_date: "",
                            payment_mode_id: "",
                            comments: "",
                            termAmountError: "",
                            dateError: "",
                        })
                    }

                }

            } else {

                let dividedAmount = Math.floor((this.state.feeAmount) / (value));
                console.log("dividedAmount", dividedAmount);
                let remainder = this.state.feeAmount % value;
                let finalCount = value;

                if (this.state.paymentArray.length > 0) {


                    if (this.state.initialPaymentChecked) {
                        finalCount = parseInt(value) + 1;
                    }

                    if (this.state.paymentArray.length > finalCount) {
                        console.log("hello");

                        for (let i = initialValue; i <= termsCount; i++) {
                            let terms = this.state.paymentArray.filter((item) => item.term_no == i);
                            if (i == 0) {
                                paymentArray.push({
                                    term_no: i,
                                    term_amount: terms[0].term_amount,
                                    term_date: terms[0].term_date,
                                    is_paid: terms[0].is_paid,
                                    paid_date: terms[0].paid_date,
                                    payment_mode_id: terms[0].payment_mode_id,
                                    comments: terms[0].comments,
                                    termAmountError: terms[0].termAmountError,
                                    dateError: terms[0].dateError,
                                })
                            } else {
                                let initialAmount = this.state.paymentArray.filter((item) => item.term_no == 0).length > 0 ? this.state.paymentArray.filter((item) => item.term_no == 0)[0].term_amount : 0
                                let dividedAmountwithoutInitial = Math.floor((this.state.feeAmount - initialAmount) / (value));
                                let remainder2 = this.state.feeAmount - (dividedAmountwithoutInitial * value);
                                let termAmountwithoutInitial = dividedAmountwithoutInitial;

                                if (i == termsCount && remainder > 0) {
                                    termAmountwithoutInitial += remainder2;
                                }
                                paymentArray.push({
                                    term_no: i,
                                    term_amount: termAmountwithoutInitial,
                                    term_date: terms[0].term_date,
                                    is_paid: terms[0].is_paid,
                                    paid_date: terms[0].paid_date,
                                    payment_mode_id: terms[0].payment_mode_id,
                                    comments: terms[0].comments,
                                    termAmountError: terms[0].termAmountError,
                                    dateError: terms[0].dateError,
                                })
                            }

                        }
                    } else {

                        console.log("hello1");
                        for (let i = initialValue; i <= termsCount; i++) {
                            let terms = this.state.paymentArray.filter((item) => item.term_no == i);
                            if (terms.length > 0) {
                                if (i == 0) {
                                    paymentArray.push({
                                        term_no: i,
                                        term_amount: terms[0].term_amount,
                                        term_date: terms[0].term_date,
                                        is_paid: terms[0].is_paid,
                                        paid_date: terms[0].paid_date,
                                        payment_mode_id: terms[0].payment_mode_id,
                                        comments: terms[0].comments,
                                        termAmountError: terms[0].termAmountError,
                                        dateError: terms[0].dateError,
                                    })
                                } else {
                                    let withoutIntitialPaymentLength = this.state.paymentArray.filter((item) => item.term_no != 0);

                                    let paidData = withoutIntitialPaymentLength.filter((val) => val.is_paid == 1);

                                    let paidAmount = paidData.length > 0 ? paidData.reduce((acc, cur) => parseInt(acc) + parseInt(cur.term_amount), 0) : 0;

                                    let initialAmount = this.state.paymentArray.filter((item) => item.term_no == 0).length > 0 ? this.state.paymentArray.filter((item) => item.term_no == 0)[0].term_amount : 0
                                    let dividedAmountwithoutInitial = Math.floor((this.state.feeAmount - initialAmount - paidAmount) / (value - (value - withoutIntitialPaymentLength.length - paidData.length)));
                                    let remainder2 = this.state.feeAmount - (dividedAmountwithoutInitial * value);
                                    let termAmountwithoutInitial = dividedAmountwithoutInitial;

                                    if (i == termsCount && remainder > 0) {
                                        termAmountwithoutInitial += remainder2;
                                    }

                                    if (terms[0].is_paid == 1) {
                                        paymentArray.push({
                                            term_no: i,
                                            term_amount: terms[0].term_amount,
                                            term_date: terms[0].term_date,
                                            is_paid: terms[0].is_paid,
                                            paid_date: terms[0].paid_date,
                                            payment_mode_id: terms[0].payment_mode_id,
                                            comments: terms[0].comments,
                                            termAmountError: terms[0].termAmountError,
                                            dateError: terms[0].dateError,
                                        })

                                    } else {
                                        paymentArray.push({
                                            term_no: i,
                                            term_amount: termAmountwithoutInitial,
                                            term_date: terms[0].term_date,
                                            is_paid: terms[0].is_paid,
                                            paid_date: terms[0].paid_date,
                                            payment_mode_id: terms[0].payment_mode_id,
                                            comments: terms[0].comments,
                                            termAmountError: terms[0].termAmountError,
                                            dateError: terms[0].dateError,
                                        })
                                    }


                                }
                            } else {
                                paymentArray.push({
                                    term_no: i,
                                    term_amount: 0,
                                    term_date: "",
                                    is_paid: 0,
                                    paid_date: "",
                                    payment_mode_id: "",
                                    comments: "",
                                    termAmountError: "",
                                    dateError: "",
                                })
                            }
                        }
                    }
                } else {
                    for (let i = initialValue; i <= termsCount; i++) {
                        if (i == 0) {
                            paymentArray.push({
                                term_no: i,
                                term_amount: 0,
                                term_date: "",
                                is_paid: 0,
                                paid_date: "",
                                payment_mode_id: "",
                                comments: "",
                                termAmountError: "",
                                dateError: "",
                            })
                        } else {
                            let termAmount = dividedAmount;
                            if (i == termsCount && remainder > 0) {
                                termAmount += remainder;
                            }
                            paymentArray.push({
                                term_no: i,
                                term_amount: termAmount,
                                term_date: "",
                                is_paid: 0,
                                paid_date: "",
                                payment_mode_id: "",
                                comments: "",
                                termAmountError: "",
                                dateError: "",
                            })
                        }
                    }
                }
            };

            if (termsCount > 0) {
                this.setState({ paymentArray: paymentArray })
            }
        } else if (name == "termsWisePayment") {

            console.log("value", value == "");

            let array = [];
            let termChangeValue = value == "" ? 0 : value;
            let termsCount = parseInt(term);
            if (this.state.initialPaymentChecked) {
                termsCount = parseInt(term) + 1
            }

            let remainingAmount = this.state.paymentArray.length > 0 ? (this.state.feeAmount - termChangeValue - this.state.paymentArray.filter((item) => item.term_no < term).reduce((acc, curr) => acc + curr.term_amount, 0)) : 0;
            let dividedAmount = Math.floor((+remainingAmount / (parseInt(this.state.paymentArray.length) - (termsCount))));
            let remainder = (+remainingAmount) % (parseInt(this.state.paymentArray.length) - (termsCount));
            let conditionDividedAmount = dividedAmount > 0 ? dividedAmount : 0;

            this.state.paymentArray.map((item, index) => {

                if (item.is_paid == "1") {
                    array.push({ ...item, termAmountError: "" })
                } else {
                    if (item.term_no < term) {
                        array.push({ ...item, termAmountError: "" })
                    } else if (item.term_no == term) {
                        array.push({ ...item, term_amount: parseInt(termChangeValue), termAmountError: "" })
                    } else {
                        let conditionalTermAmount = conditionDividedAmount;
                        if (index == (this.state.paymentArray.length - 1) && remainder > 0) {
                            conditionalTermAmount += remainder;
                        }
                        array.push({ ...item, term_amount: parseInt(conditionalTermAmount), termAmountError: "" })
                    }
                }
            })
            this.setState({ paymentArray: array, submitError: "", })
        }
    };

    initialPaymentChange = (event) => {
        let paymentArray = [];
        if (event.target.checked) {
            let array = this.state.paymentArray
            let initialObj = {
                term_no: 0,
                term_amount: 0,
                term_date: "",
                is_paid: 0,
                paid_date: "",
                payment_mode_id: 0,
                comments: "",
                termAmountError: "",
                dateError: "",


            };
            array.unshift({ ...initialObj });
            paymentArray = array
        } else {
            paymentArray = this.state.paymentArray.filter((item, index) => item.term_no != 0)
        }
        this.setState({ initialPaymentChecked: event.target.checked, paymentArray: paymentArray });
        let e = {
            target: {
                name: "terms",
                value: parseInt(this.state.termsValue)
            }
        }
        this.handleFeeFunction(e, parseInt(this.state.termsValue))
    };

    onKeyPress = (event) => {
        const name = event?.target?.name;

        let maxLength = 0;
        if (name == "totalFee" || name == "discountFee" || name == "termsWisePayment") {
            maxLength = 5
        }
        const keyCode = event.which || event.keyCode;
        const keyValue = String.fromCharCode(keyCode);

        if (!/^\d+$/.test(keyValue) || event.target.value.length > maxLength) {
            event.preventDefault();
        }
    };

    handleDateChange = async (e, term, date) => {
        e.persist();

        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        await delay(200);

        const name = e?.target?.name;
        const value = e?.target?.value;

        console.log("name", name);

        if (name == "startdate") {
            let array = []
            this.state.paymentArray.map((item, index) => {
                if (index == term) {
                    array.push({ ...item, term_date: Math.floor((new Date(date).getTime() / 1000) - 19800).toString(), dateError: "" })
                } else {
                    array.push({ ...item })
                }
            })
            this.setState({
                paymentArray: array
            })
        }

        if (name == "paidDate") {
            let array = []
            this.state.paymentArray.map((item, index) => {
                if (index == term) {
                    array.push({ ...item, paid_date: Math.floor((new Date(date).getTime() / 1000) - 19800).toString(), dateError: "" })
                } else {
                    array.push({ ...item })
                }
            })
            this.setState({
                paymentArray: array
            })
        }
    };

    paymentCheckBox = (e, term) => {

        let array = [];
        let amountAlert = false;
        let dateAlert = false;
        let disableInitialPayment = this.state.disableInitialPayment;
        this.state.paymentArray.forEach((item) => {
            if (item.term_no == term) {
                console.log("term", term, item);
                if (parseInt(term) == 0) {
                    disableInitialPayment = true
                }
                if (item.term_amount == 0) {
                    amountAlert = true;
                }
                if (item.term_date == "" && term != 0) {
                    dateAlert = true;
                }
                array.push({ ...item, is_paid: 1 });
            } else {
                array.push({ ...item });
            }
        });

        if (amountAlert) {
            window.alert("Amount must be greater than  zero !!!")
        } else if (dateAlert) {

            window.alert("Please select the term date ")
        } else {
            if (window.confirm("Are you sure you want to update the payment ?")) {
                this.setState({ paymentArray: array, disableInitialPayment });
            }
        }
    };

    downloadPDF = (i) => {
        // Extract required data
        const { studentName, getOrganisationProfile, examName, tutionFee, globals, getPaymentModes, stateData } = this.props;
        const { logo, organisation_name } = getOrganisationProfile;
        const branchWiseData = getOrganisationProfile.branch_wise_data
        const address = branchWiseData.filter((a)=> a.branch_id == stateData.row_branch_id)
        const complete_address = address[0].branch_wise_address
        const image = `https://admin.rizee.in/files/${logo}`;
        const paymentMode = getPaymentModes.find((item) => item.id === i.payment_mode_id);
        const paymentDetails = i.payment_mode_id != null ? paymentMode?.payment_mode : "";

        // Initialize PDF document
        const doc = new jsPDF();
        const lineHeightFactor = 2; // Adjust the factor as needed
        doc.setLineHeightFactor(lineHeightFactor);

        // Set margins and other constants
        const marginLeft = 10;
        const marginRight = doc.internal.pageSize.width - 10;
        const marginTop = 10;

        // Add logo and organization details
        const imgWidth = 100;
        const imgHeight = 30;
        const centerX = (doc.internal.pageSize.width - imgWidth) / 2;
        doc.addImage(image, 'JPEG', centerX, marginTop + 3, imgWidth, imgHeight);

        console.log("iiiiiii", i);

        // doc.setFontSize(12);
        // doc.text(organisation_name, (doc.internal.pageSize.width - doc.getTextWidth(organisation_name)) / 2, marginTop + 22);

        // Add wrapped complete address
        doc.setFontSize(10); // Adjust font size as needed
        const addressLines = doc.splitTextToSize(complete_address, doc.internal.pageSize.width - 20);
        doc.text(addressLines, marginLeft + 10, marginTop + 35);

        // Add header
        const headingX = (doc.internal.pageSize.width - doc.getTextWidth("PAYMENT RECEIPT") - 10) / 2;
        doc.setFont("helvetica", "bold"); // Set font and style
        doc.setFontSize(16);
        doc.text("PAYMENT RECEIPT", headingX, marginTop + 44);
        doc.setLineWidth(0.5);
        const underlineWidth = doc.getStringUnitWidth("PAYMENT RECEIPT") + 45;
        doc.line(headingX, marginTop + 46, headingX + underlineWidth, marginTop + 46);

        // Add receipt details
        const receiptNoX = marginLeft + 10;
        const dateX = marginRight - doc.getStringUnitWidth(`Date: ${moment.unix(i.paid_date).format('DD-MM-YYYY')}`) - 30;
        doc.setFontSize(12);
        doc.text(`Receipt No: ${i.payment_id}`, receiptNoX, marginTop + 60);
        doc.text(`Date: ${moment.unix(i.paid_date).format('DD-MM-YYYY')}`, dateX, marginTop + 60);

        // Add payment details
        const feeType = globals.offlineFeeTypes.find((item) => item.id == this.state.feeType).fee_type;
        console.log("feetype----------", feeType, globals.offlineFeeTypes);
        const statement = `Received with thanks from  ${studentName} (Adm No: ${stateData.roll_no}), Class: ${stateData.class_name}, Course: ${examName} the sum of Rupees ${i.term_amount} /- for ${feeType} by ${paymentDetails}`;
        const statementX = marginLeft + 20;
        doc.setFont("helvetica", "normal");
        doc.text(statement, statementX, marginTop + 70, { maxWidth: 150 });

        // Add signature
        const signatureX = marginRight - doc.getStringUnitWidth("Authorized Sign") - 50;
        doc.text("Authorized Sign", signatureX, marginTop + 100);

       

        //Add Note
        const labelText = "Note: ";
        const noteContent = "Once fee paid will not be refunded under any circumstances.";

        // Define text positions
        const noteX = marginLeft + 20;
        const labelY = marginTop + 112;
        const contentY = labelY;

        // Set font for the label (bright and underlined)
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(labelText, noteX, labelY);

        // Underline the label text
        const labelWidth = doc.getTextWidth(labelText);
        doc.setLineWidth(0.5);
        doc.line(noteX, labelY + 1, noteX + labelWidth, labelY + 1); // Draw underline

        // Set font for the note content
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        doc.text(noteContent, noteX + labelWidth, contentY);

        // Add borders
        doc.setLineWidth(0.5);
        doc.rect(marginLeft, marginTop, marginRight - marginLeft, 120);

        // Save the document
        doc.save('payment_script.pdf');
    };



    paymentModeAndComments = (e, term) => {

        console.log("e", e.target.name, e.target.value);
        let name = e.target.name;
        let value = e.target.value;
        let array = [];

        if (name == "comments") {

            this.state.paymentArray.map((item) => {
                if (item.term_no == term) {
                    array.push({ ...item, comments: value });
                } else {
                    array.push({ ...item });
                }
            });

        } else {
            this.state.paymentArray.map((item) => {
                if (item.term_no == term) {
                    array.push({ ...item, payment_mode_id: value });
                } else {
                    array.push({ ...item });
                }
            });
        }

        this.setState({ paymentArray: array });
    };

    handleFormSubmit = async (e) => {

        if (this.state.feeType == 0) {
            this.setState({ feeTypeError: "Please select Fee type" })
            return ""
        }

        if (this.state.feeAmount == "") {
            this.setState({ feeAmountError: "Please Enter Fee Amount" })
            return ""
        }

        if (this.state.termsValue == "") {
            this.setState({ termsValueError: "Please Enter Terms" })
            return ""
        }

        let resistriction = false;
        let paymentArray1 = [];
        let paymentArray2 = [];

        this.state.paymentArray.map((item) => {
            if (item.term_amount == 0 || item.term_amount == NaN) {
                paymentArray1.push({ ...item, termAmountError: "Enter valid amount" })
                resistriction = true;

            } else {
                paymentArray1.push({ ...item })
            }
        })

        this.setState({ paymentArray: paymentArray1 })

        const delay = (ms) => new Promise((r) => setTimeout(r, ms));
        await delay(200);

        this.state.paymentArray.map((item) => {
            if (item.term_no != 0 && item.term_date == "") {
                paymentArray2.push({ ...item, dateError: "Enter valid date" })
                resistriction = true;
            } else {
                paymentArray2.push({ ...item })
            }
        })

        this.setState({ paymentArray: paymentArray2 })

        if (resistriction) {
            return ""
        }

        let totalFee = this.state.feeAmount;

        let termsWiseFeesInput = this.state.paymentArray.reduce((acc, cur) => parseInt(acc) + parseInt(cur.term_amount), 0)


        if (parseInt(totalFee) != parseInt(termsWiseFeesInput)) {
            this.setState({ submitError: "Fee total is mismatching " })
            return ""
        }

        let array = [];

        this.state.paymentArray.map((item) => {
            let terms = {
                is_paid: parseInt(item.is_paid),
                term_amount: parseInt(item.term_amount),
                term_date: item.term_date != null ? item.term_date.toString() : "",
                term_no: parseInt(item.term_no),
                paid_date: item.paid_date != null ? item.paid_date.toString() : "",
                payment_mode_id: parseInt(item.payment_mode_id),
                comments: item.comments != null ? item.comments.toString() : ""
            }
            array.push(terms)
        })



        this.setState({ isSubmitting: true });

        let params = {
            student_mobile: this.props.studentMobile.toString(),
            total_fee: parseInt(this.state.totalFee),
            discount: parseInt(this.state.discountFee),
            fee_amount: parseInt(this.state.feeAmount),
            no_of_terms: parseInt(this.state.termsValue),
            initial_amount: parseInt(this.state.initial_amount),
            fee_type_id: parseInt(this.state.feeType),
            fee_terms: array
        }

        console.log("params", params);

        this.addTerms(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message) })
            setTimeout(() => {
                this.props.onHide();
            }, 5000);
        })

    };

    addTerms = async params => {
        await this.props.addTerms({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.addTerms) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0 });
        this.props.onHide();
        window.location.reload(false);
    };

    render() {

        console.log("propssss", this.props.stateData, this.props.getOrganisationProfile);

        console.log("statesss", this.state);

        const styles = {
            cursor: this.state.isSubmitting ? "not-allowed" : "pointer",
            backgroundColor: this.state.isSubmitting ? "#213046" : "#213046",
            color: this.state.isSubmitting ? "#fff" : "#fff",
            padding: this.state.isSubmitting ? "3px" : "3px",
            width: this.state.isSubmitting ? "111px" : "111px"
        };

        console.log("mahesh", styles);
        console.log("tt", this.state)
        let totalDisabled = false;
        let termsDisabled = false;

        if (this.state.feeType == "1") {
            totalDisabled = true;
        }

        if (this.state.feeAmount == "") {
            termsDisabled = true;
        }

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Fees</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <Row>
                        <Col lg={3} md={3} sm={12} className="mb-2">
                            <Form.Group as={Col} >
                                <Form.Label className='font-weight-bold'>Fee Type</Form.Label>
                                <Form.Control as="select" name="feeType" onChange={(e) => this.handleFeeFunction(e)} value={this.state.feeType}>
                                    <option value="">--Select Fee type--</option>
                                    {this.props.globals.offlineFeeTypes.map(item => (
                                        <option value={item.id}>{item.fee_type}</option>
                                    ))}
                                </Form.Control>
                                <Form.Text className="form-text text-danger">
                                    {this.state.feeTypeError}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col lg={3} md={3} sm={12} className="mb-2">
                            <Form.Group as={Col} >
                                <Form.Label className='font-weight-bold'>Total Fee</Form.Label>
                                <Form.Control type="text" placeholder="" name='totalFee' value={this.state.totalFee} onChange={(e) => this.handleFeeFunction(e)} onKeyPress={(e) => this.onKeyPress(e)} autocomplete="off" disabled={totalDisabled} />
                                <Form.Text className="form-text text-danger">
                                    {this.state.totalFeeError}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col lg={3} md={3} sm={12} className="mb-2">
                            <Form.Group as={Col} >
                                <Form.Label className='font-weight-bold'>Discount Fee</Form.Label>
                                <Form.Control type="text" placeholder="" name='discountFee' value={this.state.discountFee} onChange={(e) => this.handleFeeFunction(e)} onKeyPress={(e) => this.onKeyPress(e)} autocomplete="off" />
                                <Form.Text className="form-text text-danger">
                                    {this.state.discountFeeError}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col lg={3} md={3} sm={12} className="mb-2">
                            <Form.Group as={Col} >
                                <Form.Label className='font-weight-bold'>Committed Fee</Form.Label>
                                <Form.Control type="text" placeholder="" name='feeAmount' value={this.state.feeAmount} onChange={(e) => this.handleFeeFunction(e)} onKeyPress={(e) => this.onKeyPress(e)} autocomplete="off" disabled="true" />
                                <Form.Text className="form-text text-danger">
                                    {this.state.committedFeeError}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                        <Col lg={3} md={3} sm={12} className="mb-2">
                            <Form.Group as={Col}>
                                <Form.Label className='font-weight-bold'>Terms</Form.Label>
                                <Form.Control type="text" placeholder="" name='terms' value={this.state.termsValue} onChange={(e) => this.handleFeeFunction(e)} onKeyPress={(e) => this.onKeyPress(e)} autocomplete="off" disabled={termsDisabled} />
                                <Form.Text className="form-text text-danger">
                                    {this.state.termsValueError}
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={12} sm={12} className="mb-2">
                            <Form.Group as={Col}>
                                {
                                    this.state.termsValue != 0 && !this.state.disableInitialPayment ? (
                                        <Form.Check type="checkbox" id="checkboxOne" custom>
                                            <Form.Check.Input type="checkbox" checked={this.state.initialPaymentChecked} onChange={(e) => { this.initialPaymentChange(e) }} />
                                            <Form.Check.Label htmlFor="checkboxOne">Initial Payment</Form.Check.Label>
                                        </Form.Check>
                                    ) : ("")
                                }
                            </Form.Group>
                        </Col>
                    </Row>

                    {
                        this.state.termsValue != 0 ? (
                            this.state.paymentArray.map((item, i) => {
                                console.log("aassssaaaa", item);
                                let dateString = ''
                                if (item?.term_date != null && item?.term_date != "" && item?.term_date != "Invalid date" && item?.term_date != "1970-01-01") {
                                    dateString = moment.unix(item?.term_date).format('YYYY-MM-DD');
                                }
                                let findIndex = this.state.paymentArray.filter((item) => item.is_paid == 1).length;

                                console.log("dateString", dateString);
                                return (
                                    <>
                                        <Form.Row>
                                            <Form.Group as={Col} lg={2} md={2} sm={12} className="mb-2">
                                                <>
                                                    {
                                                        this.state.initialPaymentChecked && i == 0 ? (
                                                            <>
                                                                <p className="font-weight-bold">Initial Payment</p>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter amount"
                                                                    name="termsWisePayment"
                                                                    autoComplete="off"
                                                                    className='custom_selection mb-1'
                                                                    onChange={(e) => this.handleFeeFunction(e, item.term_no)}
                                                                    value={item.term_amount}
                                                                    disabled={item.is_paid == 0 ? false : true}
                                                                    onKeyPress={(e) => this.onKeyPress(e)}
                                                                />
                                                            </>
                                                        ) : (
                                                            <>
                                                                <p className="font-weight-bold">Term {this.state.initialPaymentChecked ? i : i + 1} Fees</p>
                                                                <Form.Control
                                                                    type="text"
                                                                    placeholder="Enter amount"
                                                                    name="termsWisePayment"
                                                                    autoComplete="off"
                                                                    className='custom_selection mb-1'
                                                                    onChange={(e) => this.handleFeeFunction(e, item.term_no)}
                                                                    value={item.term_amount}
                                                                    disabled={item.is_paid == 0 ? false : true}
                                                                    onKeyPress={(e) => this.onKeyPress(e)}
                                                                />

                                                            </>
                                                        )
                                                    }
                                                </>
                                                <Form.Text className="form-text text-danger">
                                                    {item.termAmountError}
                                                </Form.Text>
                                            </Form.Group>
                                            <Form.Group as={Col} lg={2} md={12} sm={12} className={item?.term_no == 0 ? "mb-2 d-none" : "mb-2"}   >
                                                <>
                                                    {
                                                        this.state.initialPaymentChecked && item?.term_no == 0 ? (
                                                            ""
                                                        ) : (
                                                            <>
                                                                <p className="font-weight-bold">Payment Date</p>
                                                                {
                                                                    dateString != null && dateString != "" ? (

                                                                        <Form.Control
                                                                            type="date"
                                                                            placeholder=""
                                                                            name="startdate"
                                                                            autoComplete="off"
                                                                            className='custom_selection mb-1'
                                                                            onChange={(e) => this.handleDateChange(e, i, e.target.value)}

                                                                            // min={currentDate}
                                                                            value={dateString}
                                                                            disabled={item?.is_paid == 0 ? false : true}
                                                                        />
                                                                    ) : (
                                                                        <Form.Control
                                                                            type="date"
                                                                            placeholder=""
                                                                            name="startdate"
                                                                            autoComplete="off"
                                                                            className='custom_selection mb-1'
                                                                            onChange={(e) => this.handleDateChange(e, i, e.target.value)}
                                                                            // min={currentDate}
                                                                            disabled={item?.is_paid == 0 ? false : true}
                                                                        />
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                                <Form.Text className="form-text text-danger">
                                                    {item.dateError}
                                                </Form.Text>
                                            </Form.Group>


                                            <Form.Group as={Col} lg={2} md={12} sm={12} className="mb-2">
                                                {
                                                    item?.is_paid == 1 ?
                                                        (<>
                                                            <p className="font-weight-bold">Payment Mode</p>
                                                            <Form.Control as="select" name="paymentMode" disabled={true} onClick={(e) => this.paymentModeAndComments(e, item.term_no)}>
                                                                <option value="0">select</option>
                                                                {this.props.getPaymentModes.map(payment => (
                                                                    <option selected={item.payment_mode_id == payment.id ? true : false} >{payment.payment_mode}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </>
                                                        )
                                                        :
                                                        (
                                                            findIndex == i ?
                                                                (
                                                                    <>
                                                                        <p className="font-weight-bold">Payment Mode</p>
                                                                        <Form.Control as="select" name="paymentMode" disabled={item.is_paid == 0 ? false : true} onClick={(e) => this.paymentModeAndComments(e, item.term_no)}>
                                                                            <option value="0">select</option>
                                                                            {this.props.getPaymentModes.map(payment => (
                                                                                <option value={payment.id}>{payment.payment_mode}</option>
                                                                            ))}
                                                                        </Form.Control></>
                                                                ) : ("")
                                                        )
                                                }

                                            </Form.Group>

                                            <Form.Group as={Col} lg={2} md={12} sm={12} className="mb-2">
                                                {
                                                    item?.is_paid == 1 ?
                                                        (<>
                                                            <p className="font-weight-bold">Comments</p>
                                                            <textarea class="form-control" value={item.comments} rows="2" disabled={true}></textarea>
                                                        </>
                                                        )
                                                        :
                                                        (
                                                            findIndex == i ?
                                                                (
                                                                    <>
                                                                        <p className="font-weight-bold">Comments</p>
                                                                        <textarea class="form-control" value={item.comments} rows="2" name="comments" onChange={(e) => this.paymentModeAndComments(e, item.term_no)}></textarea>
                                                                    </>
                                                                ) : ("")
                                                        )
                                                }

                                            </Form.Group>


                                            <Form.Group as={Col} lg={2} md={12} sm={12} className="mb-2">
                                                {
                                                    item?.is_paid == 1 ?
                                                        (<>
                                                            <p className="font-weight-bold">Paid Date</p>
                                                            <Form.Control
                                                                type="date"
                                                                placeholder=""
                                                                name="paidData"
                                                                autoComplete="off"
                                                                className='custom_selection mb-1'
                                                                // min={currentDate}
                                                                disabled={true}
                                                                value={item.paid_date != "" ? moment.unix(item?.paid_date).format('YYYY-MM-DD') : ""}
                                                            />
                                                        </>
                                                        )
                                                        :
                                                        (
                                                            findIndex == i ?
                                                                (
                                                                    <>
                                                                        <p className="font-weight-bold">Paid Date</p>
                                                                        <Form.Control
                                                                            type="date"
                                                                            placeholder=""
                                                                            name="paidDate"
                                                                            autoComplete="off"
                                                                            className='custom_selection mb-1'
                                                                            onChange={(e) => this.handleDateChange(e, i, e.target.value)}
                                                                            value={item.paid_date != null && item.paid_date != "" ? moment.unix(item?.paid_date).format('YYYY-MM-DD') : ""}
                                                                        />
                                                                    </>
                                                                ) : ("")
                                                        )
                                                }

                                            </Form.Group>





                                            <Form.Group as={Col} lg={2} md={12} sm={12}>
                                                <div style={{ margin: "-17px -18px -18px 10px" }}>
                                                    {
                                                        item?.is_paid == 1 ?
                                                            (
                                                                <>
                                                                    <p className="margin_top_u">Payment updated</p>
                                                                </>
                                                            )
                                                            :
                                                            (
                                                                findIndex == i ?
                                                                    (<p className="margin_top_b pl-2" onClick={(e) => this.paymentCheckBox(e, item.term_no)} style={{ backgroundColor: "#213046", marginTop: "55px", padding: "5px" }}>Make Payment</p>) : ("")
                                                            )

                                                    }
                                                    {this.state.defaultArray.filter((item1) => item1.term_no == item.term_no && item1.is_paid == 1).length > 0 ? (
                                                        <button className="pdf_button" style={styles} onClick={() => this.downloadPDF(item)}><span>Download Reciept</span></button>
                                                    ) : ("")}
                                                </div>
                                            </Form.Group>

                                        </Form.Row>
                                    </>
                                )
                            })
                        ) : ("")
                    }

                </Modal.Body>

                <Modal.Footer variant="white" className="px-4">
                    <Row>
                        {this.state.currentStep == 5 ? (
                            <Form.Text className="form-text text-danger mb-2 " style={{ textAlign: "center" }}>
                                Payment Data Saved successfully
                            </Form.Text>
                        ) : (
                            <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                {this.state.submitError}
                            </Form.Text>
                        )}
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <button onClick={(e) => this.handleFormSubmit()}
                                disabled={this.props.stateData.isSubmitting}
                                style={styles}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }
                                SUBMIT</button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    }
};
export default withRouter(withApollo(compose(
    graphql(ADD_TERMS, {
        name: "addTerms"
    })
)(FeeStatusModal)));